<h4><u>Quote Details</u></h4>
<div class="row">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Cover From:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_from" [value]="quoteApplicationData.inception_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Cover To:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_to" [value]="CoverTo | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Product:</label></div>
            <div class="col-md-6">
                <input type="text" name="product" value="Horsebox" class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Broker:</label></div>
            <div class="col-md-6">
                <input type="text" name="broker" [value]="quote &&quote.company_name?quote.company_name:'Peliwica Limited'" class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3" *ngIf="quote && quote.type == 3">
            <div class="col-md-6"><label>Effective Date:</label></div>
            <div class="col-md-6">
                <input type="text" name="cover_from" [value]="quoteApplicationData.effective_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Transaction Date:</label></div>
            <div class="col-md-6" *ngIf="quote">
                <input type="text" name="transactional_date" [value]="quote.transactional_date | date:'dd-MM-yyyy'"
                    class="form-control form-control-sm" readonly>
            </div>
            <div class="col-md-6" *ngIf="!quote">
                <input type="text" name="transactional_date" [value]=""
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
    </div>
</div>

<h4><u>Proposer Details</u></h4>
<div class="row">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Customer type:</label></div>
            <div class="col-md-6">
                <input type="text" name="proposer_type"
                    [value]="quoteApplicationData.proposer.proposer_type | titlecase"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <!--- Company Details   -->
        <div
            *ngIf="quoteApplicationData.proposer.proposer_type == 'company' || quoteApplicationData.proposer.proposer_type == 'joint'">
            <div class="row mb-3">
                <div class="col-md-6"><label>Is this client a Micro-enterprise?</label></div>
                <div class="col-md-6">
                    <mat-radio-group class="row" aria-label="Select an option" name="micro_enterprise" disabled>
                        <div class="col-md-6">
                            <div class="quote_radio">
                                <mat-radio-button value="1"
                                    [checked]="quoteApplicationData.proposer.micro_enterprise">Yes</mat-radio-button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="quote_radio">
                                <mat-radio-button value="2"
                                    [checked]="!quoteApplicationData.proposer.micro_enterprise">No</mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>{{(quoteApplicationData.proposer.proposer_type == 'joint')?'Names':'Company
                        Name'}}:</label></div>
                <div class="col-md-6">
                    <input type="text" name="company_name"
                        [value]="quoteApplicationData.proposer.company_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Trading Name:</label></div>
                <div class="col-md-6">
                    <input type="text" name="trading_name"
                        [value]="quoteApplicationData.proposer.trading_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3" *ngIf="quoteApplicationData.proposer.proposer_type == 'company'">
                <div class="col-md-6"><label>Year Company Established:</label></div>
                <div class="col-md-6">
                    <input type="text" name="year" [value]="quoteApplicationData.proposer.year"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Rating Type:</label></div>
                <div class="col-md-6">
                    <input type="text" name="year" [value]="quoteApplicationData.rating_type | uppercase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>

        <!--- Individual Details -->
        <div *ngIf="quoteApplicationData.proposer.proposer_type == 'individual'">
            <div class="row mb-3">
                <div class="col-md-6"><label>Title:</label></div>
                <div class="col-md-6">
                    <input type="text" name="title" [value]="quoteApplicationData.proposer.title | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>First Name:</label></div>
                <div class="col-md-6">
                    <input type="text" name="first_name" [value]="quoteApplicationData.proposer.first_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Last Name:</label></div>
                <div class="col-md-6">
                    <input type="text" name="last_name" [value]="quoteApplicationData.proposer.last_name | titlecase"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Date Of Birth:</label></div>
                <div class="col-md-6">
                    <input type="text" name="dob" [value]="quoteApplicationData.proposer.dob"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Type of licence:</label></div>
                <div class="col-md-6">
                    <input type="text" name="licence_type" [value]="quoteApplicationData.proposer.licence_type"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Length licence held:</label></div>
                <div class="col-md-6">
                    <input type="text" name="licence_type"
                        [value]="quoteApplicationData.proposer.licence_length | date:'dd-MM-yyyy'"
                        class="form-control form-control-sm" readonly>
                </div>
            </div>
        </div>

        <!--  Address Details -->
        <h6><u>Address Details</u></h6>
        <div class="row mb-3">
            <div class="col-md-6"><label>Address Line 1:</label></div>
            <div class="col-md-6">
                <input type="text" name="line1" [value]="quoteApplicationData.proposer.address.line1"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Address Line 2:</label></div>
            <div class="col-md-6">
                <input type="text" name="line2" [value]="quoteApplicationData.proposer.address.line2"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Address Line 3:</label></div>
            <div class="col-md-6">
                <input type="text" name="line3" [value]="quoteApplicationData.proposer.address.line3"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>County:</label></div>
            <div class="col-md-6">
                <input type="text" name="county" [value]="quoteApplicationData.proposer.address.county"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Postcode:</label></div>
            <div class="col-md-6">
                <input type="text" name="postcode" [value]="quoteApplicationData.proposer.address.postcode"
                    class="form-control form-control-sm" readonly>
            </div>
        </div>
    </div>
</div>

<div *ngIf="quoteApplicationData?.vehicles?.length" class="row">
    <div class="col-md-7">
        <h4><u>Horsebox</u></h4>
        <ng-container *ngFor="let v of quoteApplicationData.vehicles; let i = index">
            <h6><u>Horsebox {{ i + 1 }}</u></h6>
            <div class="row mb-3">
                <div class="col-md-6"><label>Registration number:</label></div>
                <div class="col-md-6">
                    <input type="text" class="form-control form-control-sm" [value]="v.registration_number" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Model</label></div>
                <div class="col-md-6">
                    <input type="text" class="form-control form-control-sm" [value]="v.model" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Make</label></div>
                <div class="col-md-6">
                    <input type="text" class="form-control form-control-sm" [value]="v.make" readonly>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6"><label>Is this vehicle kept overnight at {{ (quoteApplicationData && quoteApplicationData.proposer && quoteApplicationData.proposer.address) ? quoteApplicationData.proposer.address.postcode : '' }}?</label></div>
                <div class="col-md-6">
                    <mat-radio-group class="row" aria-label="Kept overnight" disabled>
                        <div class="col-md-6">
                            <div class="quote_radio">
                                <mat-radio-button value="1" [checked]="isKeptOvernightAtProposer(v)">Yes</mat-radio-button>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="quote_radio">
                                <mat-radio-button value="2" [checked]="!isKeptOvernightAtProposer(v)">No</mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row mb-3" *ngIf="getVehicleOvernightLines(v).length">
                <div class="col-md-6"><label>Overnight location(s)</label></div>
                <div class="col-md-6">
                    <textarea class="form-control form-control-sm" readonly rows="3">{{ getVehicleOvernightLines(v).join('\n') }}</textarea>
                </div>
            </div>
        </ng-container>
        <div class="form_sections mt-3" *ngIf="correspondenceAddressLine(quoteApplicationData) as caLine">
            <h6><u>Correspondence address</u></h6>
            <div class="row mb-3">
                <div class="col-md-12">
                    <input type="text" class="form-control form-control-sm" [value]="caLine" readonly>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="quoteApplicationData.proposer.convictions && quoteApplicationData.proposer.convictions.length > 0">
    <h4><u>Convictions</u></h4>
    <div class="row">
        <div class="col-md-7">
            <div *ngFor="let conv of quoteApplicationData.proposer.convictions; let i = index;">
                <h6><u>Conviction {{ i+1 }}</u></h6>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Conviction code:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="code_{{i}}" [value]="conv.code" class="form-control form-control-sm"
                            readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Conviction Date:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="date_{{i}}" [value]="conv.date | date:'dd-MM-yyyy'"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Number of points:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="points_{{i}}" [value]="conv.points"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Number of months banned:</label></div>
                    <div class="col-md-6">

                        <input type="text" name="banned_{{i}}" [value]="conv.banned"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Fine:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="fine_{{i}}" [value]="conv.fine | number: '1.2-2'"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="quoteApplicationData.proposer.claims && quoteApplicationData.proposer.claims.length > 0">
    <h4><u>Claims</u></h4>
    <div class="row">
        <div class="col-md-7">
            <div *ngFor="let clm of quoteApplicationData.proposer.claims; let i = index;">
                <h6><u>Claims {{ i+1 }}</u></h6>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Date of claim:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="claim_date_{{i}}" [value]="clm.date | date:'dd-MM-yyyy'"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Type of incident:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="incident_type_{{i}}" [value]="clm.type"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>AD claim cost:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="ad_cost_{{i}}" [value]="clm.ad_cost | number: '1.2-2'"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>TP claim cost:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="tp_cost_{{i}}" [value]="clm.tp_cost | number: '1.2-2'"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Total claim cost:</label></div>
                    <div class="col-md-6">
                        <input type="text" name="total_{{i}}" [value]="(clm.ad_cost + clm.tp_cost) | number: '1.2-2'"
                            class="form-control form-control-sm" readonly>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Was the driver at fault?:</label></div>
                    <div class="col-md-6">
                        <mat-radio-group class="row" aria-label="Select an option" disabled name="fault_{{i}}">
                            <div class="col-md-4">
                                <div class="quote_radio w-90">
                                    <mat-radio-button value="true" [checked]="clm.fault">Yes</mat-radio-button>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="quote_radio w-90">
                                    <mat-radio-button value="false" [checked]="!clm.fault">No</mat-radio-button>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6"><label>Is the claim still open?:</label></div>
                    <div class="col-md-6">
                        <mat-radio-group class="row" aria-label="Select an option" disabled name="open_{{i}}">
                            <div class="col-md-4">
                                <div class="quote_radio w-90">
                                    <mat-radio-button value="true" [checked]="clm.open">Yes</mat-radio-button>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="quote_radio w-90">
                                    <mat-radio-button value="false" [checked]="!clm.open">No</mat-radio-button>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="quote && quote.is_send_email == 1">
<h4><u>Contact Details</u></h4>
<div class="row">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Email: </label></div>
            <div class="col-md-6">
                <input type="text" name="email" [value]="quote?.email" class="form-control form-control-sm" readonly>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6"><label>Phone: </label></div>
            <div class="col-md-6">
                <input type="text" name="phone" [value]="quote?.phone" class="form-control form-control-sm" readonly>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-6"><label>Preferred ways to hear:</label></div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-3">
                        <mat-radio-group class="row" aria-label="Select an option" name="is_phone" disabled>
                            <div class="quote_radio">
                                <mat-radio-button value="1" [checked]="quote?.is_phone == 1">Phone</mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div class="col-md-3">
                        <mat-radio-group class="row" aria-label="Select an option" name="sms" disabled>
                            <div class="quote_radio">
                                <mat-radio-button value="1" [checked]="quote?.sms == 1">Text</mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div class="col-md-3">
                        <mat-radio-group class="row" aria-label="Select an option" name="is_email" disabled>
                            <div class="quote_radio">
                                <mat-radio-button value="1" [checked]="quote?.is_email == 1">Email</mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div class="col-md-3">
                        <mat-radio-group class="row" aria-label="Select an option" name="post" disabled>
                            <div class="quote_radio">
                                <mat-radio-button value="1" [checked]="quote?.post == 1">Post</mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</div>
</div>

<div class="row" *ngIf="isAdmin">
    <div class="col-md-7">
        <div class="row mb-3">
            <div class="col-md-6"><label>Affinity Partner: </label></div>
            <div class="col-md-6">
                <input type="text" name="affinity_partner" [value]="quote && quote.affinity_partner?quote.affinity_partner:''" class="form-control form-control-sm" readonly>
            </div>
        </div>
    </div>
</div>

<!-- ========== SADDLERY & TACK LINKED QUOTE ========== -->
<div *ngIf="sdtkQuote" class="linked-quote-section mt-4">
    <div class="linked-quote-header linked-quote-header--sdtk">
        <div class="row align-items-center">
            <div class="col-md-8">
                <h5 class="mb-0 text-white">
                    <i class="mdi mdi-shield-check mr-2"></i>Saddlery & Tack Cover
                    <!-- <span class="badge badge-light ml-2 text-capitalize">{{ sdtkQuote.status }}</span> -->
                </h5>
            </div>
        </div>
    </div>
    <div class="linked-quote-body">
        <div class="row">
            <!-- Cover & Questions -->
            <div class="col-md-6">
                <div class="linked-quote-detail-group">
                    <h6 class="linked-quote-subtitle">Cover Details</h6>
                    <div class="row mb-2">
                        <div class="col-md-6"><label class="mb-0">Cover Limit:</label></div>
                        <div class="col-md-6">
                            <span class="font-weight-bold">{{ sdtkCoverLimitName || 'N/A' }}</span>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="sdtkStorageName">
                        <div class="col-md-6"><label class="mb-0">Storage Location:</label></div>
                        <div class="col-md-6">
                            <span>
                                <i class="mdi mr-1" [ngClass]="sdtkQuote.sdtk_questions?.storage_location == 1 ? 'mdi-home-variant' : 'mdi-package-variant-closed'"></i>
                                {{ sdtkStorageName }}
                            </span>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="sdtkQuote.sdtk_questions">
                        <div class="col-md-6"><label class="mb-0">Items over £1,500:</label></div>
                        <div class="col-md-6">
                            <span [ngClass]="sdtkQuote.sdtk_questions?.has_items_over_1500 == 1 ? 'text-warning' : 'text-success'">
                                {{ sdtkQuote.sdtk_questions?.has_items_over_1500 == 1 ? 'Yes' : 'No' }}
                            </span>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="sdtkQuote.sdtk_questions">
                        <div class="col-md-6"><label class="mb-0">Legal Owner:</label></div>
                        <div class="col-md-6">
                            <span>{{ sdtkQuote.sdtk_questions?.is_legal_owner == 1 ? 'Yes' : 'No' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Financial Summary -->
            <div class="col-md-6">
                <div class="linked-quote-detail-group">
                    <h6 class="linked-quote-subtitle">Financial Summary</h6>
                    <div *ngIf="!sdtkIsTbc">
                        <div class="row mb-2">
                            <div class="col-md-6"><label class="mb-0">Premium (excl IPT):</label></div>
                            <div class="col-md-6">
                                <span>&pound;{{ sdtkPremiumExclIpt | number:'1.2-2' }}</span>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-6"><label class="mb-0">IPT:</label></div>
                            <div class="col-md-6">
                                <span>&pound;{{ sdtkIpt | number:'1.2-2' }}</span>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-6"><label class="mb-0 font-weight-bold">Total (incl IPT):</label></div>
                            <div class="col-md-6">
                                <span class="font-weight-bold linked-quote-total">&pound;{{ sdtkTotalInclIpt | number:'1.2-2' }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="sdtkIsTbc" class="text-center py-3">
                        <span class="badge badge-warning px-3 py-2">Premium: TBC</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- High Value Items -->
        <div *ngIf="sdtkQuote.vehicles && sdtkQuote.vehicles.length > 0" class="mt-3">
            <h6 class="linked-quote-subtitle">High Value Items</h6>
            <div class="table-responsive">
                <table class="table table-sm table-bordered mb-0">
                    <thead class="thead-light">
                        <tr>
                            <th>#</th>
                            <th>Make</th>
                            <th>Model</th>
                            <th>Type</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of sdtkQuote.vehicles; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ item.make }}</td>
                            <td>{{ item.model }}</td>
                            <td>{{ item.type }}</td>
                            <td>&pound;{{ item.value | number:'1.2-2' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- ========== EXCESS PROTECT LINKED QUOTE ========== -->
<div *ngIf="epQuote" class="linked-quote-section mt-4">
    <div class="linked-quote-header linked-quote-header--ep">
        <div class="row align-items-center">
            <div class="col-md-8">
                <h5 class="mb-0 text-white">
                    <i class="mdi mdi-shield-plus mr-2"></i>Excess Protect Cover
                    <!-- <span class="badge badge-light ml-2 text-capitalize">{{ epQuote.status }}</span> -->
                </h5>
            </div>
        </div>
    </div>
    <div class="linked-quote-body">
        <div class="row">
            <!-- Cover Details -->
            <div class="col-md-6">
                <div class="linked-quote-detail-group">
                    <h6 class="linked-quote-subtitle">Cover Details</h6>
                    <div class="row mb-2">
                        <div class="col-md-6"><label class="mb-0">Cover Option:</label></div>
                        <div class="col-md-6">
                            <span class="font-weight-bold">{{ epCoverLimitName || 'N/A' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Financial Summary -->
            <div class="col-md-6">
                <div class="linked-quote-detail-group">
                    <h6 class="linked-quote-subtitle">Financial Summary</h6>
                    <div class="row mb-2">
                        <div class="col-md-6"><label class="mb-0">Premium (excl IPT):</label></div>
                        <div class="col-md-6">
                            <span>&pound;{{ epPremiumExclIpt | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6"><label class="mb-0">IPT:</label></div>
                        <div class="col-md-6">
                            <span>&pound;{{ epIpt | number:'1.2-2' }}</span>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6"><label class="mb-0 font-weight-bold">Total (incl IPT):</label></div>
                        <div class="col-md-6">
                            <span class="font-weight-bold linked-quote-total">&pound;{{ epTotalInclIpt | number:'1.2-2' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

